import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment.prod';
@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private HTTP: HttpClient) {

    }
    // Post(model: any, _getUrl: string): Observable<any> {
    //     var _Requesturl = `${environment.apiBase}` + _getUrl;
    //     console.log(_Requesturl);
    //     return this.HTTP.post<any>(_Requesturl, model);
    // }
    // get(_getUrl: strinag): Observable<any[]> {
    //     var _Requesturl = `${environment.apiBase}` + _getUrl;
    //     return this.HTTP.get<any[]>(_getUrl);
    // }
}